import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { Client } from '@df/core/service/client';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { PaymentIconComponent } from '../../ui/display/payment-icon/payment-icon.component';
import { NBasketViewCms } from '../view/basket-view-cms.component';

@Component({
    selector: 'basket-view-pay-with',
    templateUrl: './basket-view-pay-with.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, PaymentIconComponent, TranslationModule]
})
export class BasketViewPayWithComponent {
    client = inject(Client);

    @Input()
    paymentMethods?: NBasketViewCms.IPaymentMethodIcon[];
}
